<template>
    <div class="grow-0 overflow-visible border border-v2-gray-110 flex h-20 items-center relative shrink-0 dark:border-v2-gray-10">
        <button
            @click="isNewTrayFromOpen=!isNewTrayFromOpen"
            :aria-expanded="isNewTrayFromOpen"
            class="border-t dark:border-v2-gray-10 gap-2 at1024:gap-3 text-sm at1200:text-base absolute bottom-0 flex items-center bg-white dark:bg-v2-gray-60 font-medium z-50 p-7 w-full text-v2-gray-20 dark:text-v2-white"
            :class="isNewTrayFromOpen
            ? 'group'
            : ''"
        >
            <BaseSvg
                :name="isNewTrayFromOpen?'Close':'Add'"
                aria-hidden="true"
                :class="isNewTrayFromOpen
                 ? 'border border-v2-red fill-v2-red p-1 rounded size-6 group-hover:bg-v2-gray-130 dark:group-hover:bg-v2-gray-70'
                 : 'bg-v2-green fill-v2-white p-1 rounded size-6 dark:bg-v2-gray-40 dark:border dark:border-v2-green dark:fill-v2-green'"
            />
            {{ isNewTrayFromOpen ? "Cancel" : "Create new tray" }}
        </button>
        <form
            v-click-outside="closeForm"
            v-if="isNewTrayFromOpen"
            class="absolute bg-gradient-to-t from-v2-gray-120 to-v2-gray-130 to-10% bottom-full flex gap-3 px-6 py-8 w-full z-0 at1350:p-10 dark:bg-none dark:bg-v2-gray-30"
        >
            <span
                aria-hidden="true"
                class="bg-v2-white flex items-center justify-center rounded-md shrink-0 size-10 at1350:size-14 dark:bg-v2-gray-50"
            >
                <span class="font-medium text-[12px] text-v2-gray-70 uppercase dark:text-v2-gray-90">New</span>
            </span>
            <div class="grow">
                <fieldset class="flex flex-col gap-2">
                    <label for="tray-name" class="sr-only">Tray name</label>
                    <input
                        type="text"
                        name="tray-name"
                        id="tray-name"
                        ref="trayNameInput"
                        :disabled="isLoading"
                        v-model="nameInput"
                        class="border-v2-blue rounded dark:bg-v2-gray-40"
                        placeholder="Tray name"
                    />
                    <label for="tray-description" class="sr-only">Tray description (optional)</label>
                    <textarea
                        name="tray-description"
                        :disabled="isLoading"
                        id="tray-description"
                        v-model="descriptionInput"
                        class="border-v2-gray-110 rounded dark:bg-v2-gray-40 dark:border-v2-gray-10"
                        placeholder="Tray description (optional)"
                    ></textarea>
                </fieldset>
                <div class="mt-2 text-right">
                    <button
                        @click.prevent="submitForm"
                        type="button"
                        :disabled="isLoading || !nameInput"
                        class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-gray-110 font-medium leading-none px-4 py-3 rounded text-v2-gray-20 text-xs hover:bg-v2-gray-140 dark:bg-v2-gray-60 dark:border-v2-gray-10 dark:text-v2-white dark:hover:bg-v2-gray-70"
                    >
                        <LoadingCircle v-if="isLoading" class="w-4 h-4" />
                        <span v-else>Create</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import {nextTick, ref, watch} from "vue";
import {usePinsDrawer} from "@/Composables";
import {LoadingCircle} from "@/Components";

const isNewTrayFromOpen = ref(false);
const trayNameInput = ref();
const nameInput = ref('');
const descriptionInput = ref('');
const { createTray, isLoading } = usePinsDrawer();

function submitForm () {
    try {
        createTray(nameInput.value, descriptionInput.value, 'icon-pin-tray');
        closeForm()
    } catch (e) {
        console.error('Error:', e);
    }
}

function closeForm () {
    nameInput.value = '';
    descriptionInput.value = '';
    isNewTrayFromOpen.value = false;
}

watch(() => isNewTrayFromOpen.value, () => {
    if(isNewTrayFromOpen.value){
        nextTick(() => {
            trayNameInput.value.focus();
        })
    }
})

</script>
